<template>
  <div class="page privacy-page">
    <section class="privacy-hero">
      <div class="privacy-hero__inner">
        <p class="eyebrow">Nyenyezia Forex</p>
        <h1>{{ isEnglish ? 'Privacy Policy' : 'Politique de confidentialité' }}</h1>
        <p>{{ isEnglish ? 'A simple summary of how we handle information submitted through this website.' : 'Un résumé simple de la façon dont nous traitons les informations envoyées sur ce site.' }}</p>
        <span>{{ isEnglish ? 'Last updated: March 8, 2025' : 'Dernière mise à jour : 8 mars 2025' }}</span>
      </div>
    </section>

    <main class="privacy-content">
      <article v-if="!isEnglish" class="policy-card">
        <section class="section">
          <h2>1. Objet de cette politique</h2>
          <p>
            Cette politique explique, de façon simple, quelles informations Nyenyezia Forex peut recevoir lorsque vous utilisez le site public ou le formulaire de contact.
          </p>
        </section>

        <section class="section">
          <h2>2. Informations que nous pouvons recevoir</h2>
          <ul>
            <li>Vos coordonnées lorsque vous nous écrivez : nom, adresse email, téléphone si vous le fournissez, sujet et message.</li>
            <li>Les informations nécessaires pour répondre à une demande de service, de change ou de transfert.</li>
            <li>Des données techniques de base liées au fonctionnement du site, comme le navigateur, l’adresse IP ou les journaux de sécurité.</li>
          </ul>
        </section>

        <section class="section">
          <h2>3. Utilisation des informations</h2>
          <p>Nous utilisons ces informations pour répondre à vos demandes, préparer un suivi avec l’équipe et maintenir le bon fonctionnement du site.</p>
          <p>Nous ne vendons pas les informations envoyées via le formulaire de contact.</p>
        </section>

        <section class="section">
          <h2>4. Taux de change affichés</h2>
          <p>
            Les taux affichés sur le site sont fournis à titre informatif. Ils peuvent varier selon le moment, la disponibilité, les montants et la confirmation finale par l’équipe.
          </p>
        </section>

        <section class="section">
          <h2>5. Partage limité</h2>
          <p>
            Nous pouvons partager certaines informations uniquement lorsque cela est nécessaire pour traiter votre demande, respecter une obligation légale ou utiliser un prestataire technique qui aide au fonctionnement du site.
          </p>
        </section>

        <section class="section">
          <h2>6. Sécurité et conservation</h2>
          <p>
            Nous prenons des mesures raisonnables pour protéger les informations reçues. Aucun système n’est parfait, mais nous cherchons à limiter l’accès aux personnes qui en ont besoin pour répondre aux demandes.
          </p>
        </section>

        <section class="section">
          <h2>7. Vos demandes</h2>
          <p>
            Vous pouvez nous demander de consulter, corriger ou supprimer les informations de contact que vous nous avez envoyées, lorsque cela est possible et conforme aux obligations applicables.
          </p>
        </section>

        <section class="section contact-section">
          <h2>8. Contact</h2>
          <p>
            Pour toute question concernant cette politique, écrivez-nous à
            <a href="mailto:info@nyenyeziaforex.com" class="contact-link">info@nyenyeziaforex.com</a>.
          </p>
        </section>
      </article>

      <article v-else class="policy-card">
        <section class="section">
          <h2>1. Purpose of this policy</h2>
          <p>
            This policy explains, in simple terms, what information Nyenyezia Forex may receive when you use the public website or contact form.
          </p>
        </section>

        <section class="section">
          <h2>2. Information we may receive</h2>
          <ul>
            <li>Contact details when you write to us: name, email address, phone number if provided, subject, and message.</li>
            <li>Information needed to respond to a service, exchange, or transfer request.</li>
            <li>Basic technical data related to website operation, such as browser, IP address, or security logs.</li>
          </ul>
        </section>

        <section class="section">
          <h2>3. How we use information</h2>
          <p>We use this information to answer requests, prepare follow-up with the team, and keep the website working properly.</p>
          <p>We do not sell information submitted through the contact form.</p>
        </section>

        <section class="section">
          <h2>4. Exchange rates shown on the site</h2>
          <p>
            Rates shown on the website are provided for information only. They may vary depending on timing, availability, amounts, and final confirmation by the team.
          </p>
        </section>

        <section class="section">
          <h2>5. Limited sharing</h2>
          <p>
            We may share certain information only when needed to process your request, comply with a legal obligation, or use a technical provider that helps operate the website.
          </p>
        </section>

        <section class="section">
          <h2>6. Security and retention</h2>
          <p>
            We take reasonable steps to protect information we receive. No system is perfect, but we aim to limit access to people who need it to respond to requests.
          </p>
        </section>

        <section class="section">
          <h2>7. Your requests</h2>
          <p>
            You can ask us to review, correct, or delete contact information you sent to us, when possible and consistent with applicable obligations.
          </p>
        </section>

        <section class="section contact-section">
          <h2>8. Contact</h2>
          <p>
            For questions about this policy, contact us at
            <a href="mailto:info@nyenyeziaforex.com" class="contact-link">info@nyenyeziaforex.com</a>.
          </p>
        </section>
      </article>
    </main>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  computed: {
    isEnglish() {
      return this.$route.path.startsWith('/en');
    }
  }
};
</script>

<style scoped>
.privacy-page {
  background: #f4f7fb;
  color: #172033;
}

.privacy-hero {
  background: #001041;
  color: #fff;
  padding: 78px 20px 58px;
}

.privacy-hero__inner {
  margin: 0 auto;
  max-width: 920px;
}

.eyebrow {
  color: #45a5f6;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0;
  margin: 0 0 7px;
  text-transform: uppercase;
}

.privacy-hero h1 {
  font-size: clamp(2rem, 5vw, 3.4rem);
  line-height: 1.08;
  margin: 0 0 14px;
}

.privacy-hero p {
  font-size: 1.05rem;
  line-height: 1.65;
  margin: 0 0 18px;
  max-width: 720px;
}

.privacy-hero span {
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  display: inline-block;
  padding: 9px 12px;
}

.privacy-content {
  margin: 0 auto;
  max-width: 920px;
  padding: 38px 20px 72px;
}

.policy-card {
  background: #fff;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  box-shadow: 0 16px 36px rgba(0, 16, 65, 0.08);
  padding: 10px 28px;
}

.section {
  border-bottom: 1px solid #e5ebf3;
  padding: 22px 0;
}

.section:last-child {
  border-bottom: none;
}

.section h2 {
  color: #001041;
  font-size: 1.22rem;
  margin: 0 0 10px;
}

.section p,
.section li {
  color: #43526a;
  font-size: 1rem;
  line-height: 1.7;
}

.section p {
  margin: 0 0 10px;
}

.section p:last-child {
  margin-bottom: 0;
}

.section ul {
  margin: 0;
  padding-left: 20px;
}

.section li {
  margin-bottom: 8px;
}

.contact-section {
  background: #f8fafc;
  border-radius: 8px;
  margin: 18px 0;
  padding: 20px;
}

.contact-link {
  color: #007acc;
  font-weight: 700;
  text-decoration: none;
}

.contact-link:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .privacy-hero {
    padding: 64px 18px 48px;
  }

  .privacy-content {
    padding: 24px 12px 54px;
  }

  .policy-card {
    padding: 4px 18px;
  }
}
</style>
